<template>
  <div class="profession-container">
    <div v-title :data-title=" professionInfo.professionName + '_专业简介' "></div>
    <div class="app" :data="professionInfo">
      <h1>{{professionInfo.professionName}}</h1>
      <ul>
        <li><span>学历层次</span>{{professionInfo.educationLevel}}</li>
        <li><span>专业代码</span>{{professionInfo.professionCode}}</li>
        <li><span>门类</span>{{professionInfo.category}}</li>
        <li><span>专业类</span>{{professionInfo.professionCategory}}</li>
      </ul>
      <h3>专业介绍</h3>
      <el-divider></el-divider>
      <p>{{professionInfo.professionDescription}}</p>
      <h3>统计信息<span>（数据统计截止日期：2021年11月25日）</span></h3>
      <el-divider></el-divider>
      <div class="statistics">
        <div class="left">
            <p>全国普通高校毕业生规模：</p>
            <p v-if="graduationSize != null ">{{professionInfo.graduationSize}}人</p>
            <p v-else>-</p>
        </div>
        <div class="right">
          <p>男女比例：</p>
          <p v-if="malePercent != 0 ">男{{professionInfo.malePercent}}%---女{{professionInfo.femalePercent}}%</p>
          <p v-else>-</p>
        </div>
      </div>
      <div class="box clearfix">
        <div class="left">
          <h3>专业满意度<span>(本专业学生实名投票)</span></h3>
          <el-divider></el-divider>
          <table v-if="professionSatisfaction.overallSatisfaction != 0.0">
            <tr>
              <td>综合满意度:</td>
              <td>{{professionSatisfaction.overallSatisfaction}}</td>
              <td>{{professionSatisfaction.overallPeopleNumber}}人</td>
            </tr>
            <tr>
              <td>办学条件满意度:</td>
              <td>{{professionSatisfaction.conditionSatisfaction}}</td>
              <td>{{professionSatisfaction.conditionPeopleNumber}}人</td>
            </tr>
            <tr>
              <td>教学质量满意度:</td>
              <td>{{professionSatisfaction.teachQualitySatisfaction}}</td>
              <td>{{professionSatisfaction.teachQualityPeopleNumber}}人</td>
            </tr>
            <tr>
              <td>就业满意度:</td>
              <td>{{professionSatisfaction.workingSatisfaction}}</td>
              <td>{{professionSatisfaction.workingPeopleNumber}}人</td>
            </tr>
          </table>
          <table v-else>
            <tr>
              <td style="color: #ccc">投票人数较少，暂无数据</td>
            </tr>
          </table>
        </div>
        <div class="right">
          <h3>本专业推荐指数较高的高校<span>(本校学生实名推荐）</span></h3>
          <el-divider></el-divider>
          <ul v-if="len > 0">
            <li v-for="schoolInfo in schoolList" :key="schoolInfo.id">
              <span>{{schoolInfo.schoolName}} </span>
              <span>（{{schoolInfo.recommendPeopleNumber}}人）</span>
              <span>{{schoolInfo.recommendScore.toFixed(1)}}</span>
            </li>
          </ul>
          <ul v-else>
            <li style="text-align: left; color: #ccc">推荐人数较少，暂无数据</li>
          </ul>
        </div>
      </div>
      <h3>相近专业</h3>
      <el-divider></el-divider>
      <p>{{professionInfo.similarProfession}} </p>
      <h3>该专业学生考研方向</h3>
      <el-divider></el-divider>
      <p>{{professionInfo.postgraduateDirection}}</p>
      <h3>已毕业人员从业方向</h3>
      <el-divider></el-divider>
      <p>{{professionInfo.workingDirection}}</p>
    </div>
  </div>
</template>

<script>
import profession from '../../api/configuration'
export default {
  name: 'ProfessionInfo',
  data() {
    return {
      professionInfo: {}, //当前页要展示的列表数据
      schoolList: [],
      len: 1,
      professionSatisfaction: {},
      graduationSize: '',
      malePercent: 0,
      code: this.$route.query.code
    }
  },
  methods: {
    getProfession() {
      profession.getProfession(this.code).then(res => {
        this.professionInfo = res.professionInfo
        this.schoolList = res.professionInfo.highIndexSchoolsList
        this.professionSatisfaction = res.professionInfo.professionSatisfaction
        this.len = this.schoolList.length
        this.graduationSize = res.professionInfo.graduationSize
        this.malePercent = res.professionInfo.malePercent
      })
    }
  },
  directives: {
    title(el, binding) {
      document.title = el.dataset.title
    }
  },
  created() {
    this.getProfession()
  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.clearfix {
  clear: both;
}
.profession-container {
  background-color: #fff;
}
.app {
  width: 1200px;
  margin: 0 auto;
}
.app h1 {
  margin-bottom: 10px;
  text-align: center;
  font-size: 40px;
  font-weight:400;
}
.app ul {
  padding-top: 20px;
  height: 40px;
  text-align: center;
  list-style: none;
}
.app ul li {
  float: left;
  margin-right: 120px;
}
.app ul li span {
  padding: 0 5px;
  border: 1px solid #adeed6;
  background: #effef9;
  margin-right: 10px;
}
.app h3 {
  margin-top: 50px;
  padding-left: 10px;
  border-left: 3px solid #1db278;
  margin-bottom: 15px;
}
.app p {
  padding: 30px 20px;
  line-height: 2;
}
.app h3 span {
  color: #ccc;
  font-size: 14px;
  font-weight: 400;
}
.statistics {
  height: 100px;
  padding: 30px 20px;
}
.statistics .left {
  float: left;
  width: 400px;
  height: 70px;
  background-color: #f2fdfc;
  padding-left: 100px;
}
.statistics .left p {
  padding: 0;
  margin: 0;
}
.statistics .left p:last-child,
.statistics .right p:last-child {
  color: #6acda8;
}
.statistics .right {
  float: right;
  width: 400px;
  height: 70px;
  background-color: #f2fdfc;
  padding-left: 100px;
}
.statistics .right p {
  padding: 0;
  margin: 0;
}
.box {
  display: flex;
  margin-top: 50px;
}
.box .left {
  flex: 1;
  margin-right: 150px;
}
.box .left table {
  padding-left: 20px;
}
.box .left table {
  padding: 0;
  margin: 0;
  border-collapse: separate;
  border-spacing: 100px 20px;
  margin-left: -80px;
}
.box .right {
  flex: 1;
}

.box .right ul {
  padding-left: 20px;
}
.box .right li {
  width: 100%;
  line-height: 42px;
}
.box .right li:nth-child(2n) {
  background-color: #f1fefa;
}
.box .right li span {
  border: 0;
  background: none;
}
.box .right li span:first-child {
  float: left;
}
.box .right li span:nth-child(2) {
  float: right;
}
.box .right li span:last-child {
  float: right;
}
</style>